module.exports = __webpack_public_path__ + "img/delete.b45b5c3c.png";